import { css } from '@emotion/react';

const styles = {
  btnContainer: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
};

type MFAButtonRowProps = {
  children: React.ReactNode;
};

export function MFAButtonRow({ children }: MFAButtonRowProps) {
  return <div css={styles.btnContainer}>{children}</div>;
}
